import { SxProps } from '@mui/system';
import { Theme } from 'theme';

export const contentStyle: SxProps<Theme> = theme => ({});
